import { render, staticRenderFns } from "./UserTabErgasiaka.vue?vue&type=template&id=76f80722"
import script from "./UserTabErgasiaka.vue?vue&type=script&lang=js"
export * from "./UserTabErgasiaka.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports